<div class="form-templates-container">

  <!-- Header -->
  <div class="templates-header">
    <div class="templates-title">
      <div class="title-icon">
        <i class="fa-solid fa-file-lines"></i>
      </div>
      <div class="title-text">
        <h1>Formularios</h1>
        <span class="subtitle">Plantillas</span>
      </div>
    </div>

    <div class="templates-toolbar">
      <div class="toolbar-filters">
        <p-select [options]="SortOptions" optionLabel="label" optionValue="value"
          [(ngModel)]="SelectedSort" (onChange)="ApplyFilters()" placeholder="Más reciente">
        </p-select>

        <p-select [options]="StatusOptions" optionLabel="label" optionValue="value"
          [(ngModel)]="SelectedStatus" (onChange)="OnStatusChange()" placeholder="Todos">
        </p-select>
      </div>

      <div class="search-box">
        <i class="fa-solid fa-magnifying-glass search-icon"></i>
        <input type="text" pInputText [(ngModel)]="SearchText"
          (input)="ApplyFilters()" placeholder="Buscar formulario..." />
      </div>
    </div>
  </div>

  <!-- Stats Bar -->
  <div class="stats-bar" *ngIf="Templates.length > 0">
    <div class="stat-pill">
      <span class="stat-num">{{ Templates.length }}</span>
      <span class="stat-label">Total</span>
    </div>
    <div class="stat-divider"></div>
    <div class="stat-pill">
      <span class="stat-dot dot-active"></span>
      <span class="stat-num">{{ GetTemplateCountByStatus(2) }}</span>
      <span class="stat-label">Activos</span>
    </div>
    <div class="stat-divider"></div>
    <div class="stat-pill">
      <span class="stat-dot dot-draft"></span>
      <span class="stat-num">{{ GetTemplateCountByStatus(1) }}</span>
      <span class="stat-label">Borradores</span>
    </div>
    <div class="stat-divider"></div>
    <div class="stat-pill">
      <span class="stat-dot dot-archived"></span>
      <span class="stat-num">{{ GetTemplateCountByStatus(3) }}</span>
      <span class="stat-label">Archivados</span>
    </div>
  </div>

  <!-- Gallery Grid -->
  <div class="templates-gallery" *ngIf="FilteredTemplates.length > 0; else emptyState">
    <div *ngFor="let template of FilteredTemplates"
      class="template-card"
      (click)="NavigateToBuilder(template.ID)">

      <!-- Card Preview -->
      <div class="card-preview">
        <div class="card-preview-inner">
          <div class="card-doc-icon">
            <i class="fa-solid fa-file-lines"></i>
          </div>
          <div class="card-doc-lines">
            <span></span><span></span><span></span><span class="short"></span>
          </div>
        </div>

        <!-- Status Badge -->
        <span class="card-status" [ngClass]="GetStatusClass(template.Status)">
          <i class="fa-solid fa-circle status-dot-icon"></i>
          {{ GetStatusLabel(template.Status) }}
        </span>

        <!-- Action Buttons (appear on hover or toggle, top-left) -->
        <div class="card-actions" *ngIf="UserService.UserRoleGeneralIn([RolesGeneral.FormTemplatesAdmin])"
          [class.active]="activeMenuId === template.ID"
          (click)="$event.stopPropagation()">
          <button class="action-btn action-ai" title="Editar con IA" (click)="NavigateToGenAI(template.ID)">
            <i class="fa-solid fa-wand-magic-sparkles"></i>
          </button>
          <button class="action-btn" title="Duplicar" (click)="DuplicateTemplate(template)">
            <i class="fa-regular fa-copy"></i>
          </button>
          <!-- Archivar / Desarchivar según estado -->
          <button class="action-btn" title="Desarchivar"
            *ngIf="template.Status === 3"
            (click)="UnarchiveTemplate(template)">
            <i class="fa-solid fa-box-open"></i>
          </button>
          <button class="action-btn" title="Archivar"
            *ngIf="template.Status !== 3"
            (click)="ArchiveTemplate(template)">
            <i class="fa-solid fa-box-archive"></i>
          </button>
          <button class="action-btn action-danger" title="Eliminar" (click)="DeleteTemplate(template)">
            <i class="fa-regular fa-trash-can"></i>
          </button>
        </div>

        <!-- More Button (visible on mobile/tablet) -->
        <button class="more-btn" *ngIf="UserService.UserRoleGeneralIn([RolesGeneral.FormTemplatesAdmin])"
          [class.active]="activeMenuId === template.ID"
          (click)="ToggleMenu(template.ID, $event)">
          <i class="fa-solid fa-ellipsis-vertical"></i>
        </button>
      </div>

      <!-- Card Info -->
      <div class="card-info">
        <div class="card-name">{{ template.Name }}</div>
        <div class="card-meta-row">
          <span class="meta-time">
            <i class="fa-regular fa-clock"></i> {{ GetTimeAgo(template.Date_Created) }}
          </span>
          <span class="meta-sep">·</span>
          <span class="meta-version">V{{ template.Version }}</span>
          <ng-container *ngIf="template.Category">
            <span class="meta-sep">·</span>
            <span class="meta-category">
              <i class="fa-solid fa-tag"></i> {{ template.Category }}
            </span>
          </ng-container>
        </div>
      </div>

      <!-- Bottom status bar -->
      <div class="card-bottom-bar" [ngClass]="GetStatusClass(template.Status)"></div>
    </div>
  </div>

  <!-- Empty State -->
  <ng-template #emptyState>
    <div class="empty-state">
      <div class="empty-illustration">
        <div class="empty-circle">
          <i class="fa-solid fa-box-open" *ngIf="SelectedStatus === 3"></i>
          <i class="fa-solid fa-file-circle-plus" *ngIf="SelectedStatus !== 3"></i>
        </div>
      </div>

      <ng-container *ngIf="SelectedStatus === 3">
        <h2>No hay formularios archivados</h2>
        <p>Los formularios que archives aparecerán aquí.</p>
      </ng-container>

      <ng-container *ngIf="SelectedStatus !== 3">
        <h2>No hay formularios</h2>
        <p>Crea tu primer formulario para digitalizar tus documentos y procesos.</p>
        <button class="empty-cta" (click)="NavigateToBuilder()"
          *ngIf="CanManageFormTemplates()">
          <i class="fa-solid fa-plus"></i> Crear formulario
        </button>
      </ng-container>
    </div>
  </ng-template>

  <!-- Floating Action Buttons -->
  <div class="fab-container" *ngIf="CanManageFormTemplates()">
    <button class="fab-button fab-ai" (click)="NavigateToGenAI()">
      <i class="fa-solid fa-wand-magic-sparkles"></i>
      <span>Generar con IA</span>
    </button>
    <button class="fab-button fab-primary" (click)="NavigateToBuilder()">
      <i class="fa-solid fa-plus"></i>
      <span>Crear formulario</span>
    </button>
  </div>

</div>
